import { Box, Button, Chip, Typography } from '@mui/joy';

interface TagFilterBarProps {
  tags: string[];
  selected: Set<string>;
  onToggle: (tag: string) => void;
  onClear: () => void;
}

/** Clickable tag chips; experiments must carry every selected tag. */
export default function TagFilterBar({
  tags,
  selected,
  onToggle,
  onClear,
}: TagFilterBarProps) {
  if (tags.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        flexWrap: 'wrap',
        alignItems: 'center',
        mb: 2,
      }}
    >
      <Typography level="body-xs" color="neutral" sx={{ mr: 0.5 }}>
        Filter by tag:
      </Typography>
      {tags.map((t) => {
        const isSelected = selected.has(t);
        return (
          <Chip
            key={t}
            size="sm"
            variant={isSelected ? 'solid' : 'soft'}
            color={isSelected ? 'primary' : 'neutral'}
            onClick={() => onToggle(t)}
            slotProps={{ action: { 'aria-pressed': isSelected } }}
          >
            {t}
          </Chip>
        );
      })}
      {selected.size > 0 && (
        <Button size="sm" variant="plain" onClick={onClear}>
          Clear
        </Button>
      )}
    </Box>
  );
}
